<!-- eslint-disable vue/no-parsing-error -->
<!-- eslint-disable prettier/prettier -->
<template>
  <div class="payment-container">
    <div class="header">
      <h4 class="title is-5"> {{ $t('helloPage.onlineCheckinPage1.title', { applicantName: applicantName }) }}</h4>
      <language-selector></language-selector>
    </div>
    <div class="stripe-div" v-if="pi">
      <stripe-element-payment v-on:error="onStripeError" v-on:loading="loading = !loading"
        v-on:element-change="onStripeElementChange" ref="paymentRef" :pk="pk" :elements-options="elementsOptions"
        :confirm-params="confirmParams" class="payment" />
      <b-button @click="pay" :disabled="loading || !stripeElementComplete" type="is-primary"
        :class="{ 'is-loading': loading }">
        {{ loading ? "Patientez ..." : "Valider (" + (new Intl.NumberFormat('fr-FR', {
          minimumFractionDigits: 2,
          maximumFractionDigits: 2,
        }).format(totalAmount / 100))
          + "€)" }}
      </b-button>
      <div class="collapses">
        <b-collapse class="card" animation="slide" v-for="(collapse, index) of collapses" :key="index"
          :open="isOpen == index" @open="isOpen = index" :aria-id="'contentIdForA11y5-' + index">
          <template #trigger="props">
            <div class="card-header" role="button" :aria-controls="'contentIdForA11y5-' + index"
              :aria-expanded="props.open">
              <a class="card-header-icon">
                <b-icon :icon="props.open ? 'chevron-down' : 'chevron-right'">
                </b-icon>
              </a>
              <p class="card-header-title">
                {{ collapse.securityFees == true ? (depositWithoutFees
                  ? $t("helloPage.onlineCheckinPage2.depositOnly.standardDepositOption3.cardTitle")
                  : $t("helloPage.onlineCheckinPage2.depositOnly.insuranceFeesOption1.cardTitle")) : (collapse.commitment ? $t("helloPage.onlineCheckinPage2.depositOnly.insuranceFeesOption1.commitmentTitle") :
                    $t("helloPage.onlineCheckinPage2.depositOnly.insuranceFeesOption1.securityTitle")) }}
              </p>
            </div>

          </template>
          <div class="card-content">
            <div class="content">
              {{ collapse.securityFees == true ? (depositWithoutFees
                ? $t("helloPage.onlineCheckinPage2.depositOnly.standardDepositOption3.securityFeesTextWithoutFees")
                : $t("helloPage.onlineCheckinPage2.depositOnly.insuranceFeesOption1.securityFeesText")) : (collapse.commitment ? $t("helloPage.onlineCheckinPage2.depositOnly.insuranceFeesOption1.commitmentText") :
                  $t("helloPage.onlineCheckinPage2.depositOnly.insuranceFeesOption1.securityText")) }}<span class="pointer" style="text-decoration: underline"
                @click="activateWithoutFees" v-if="collapse.securityFees == true">{{ $t('helloPage.onlineCheckinPage2.depositOnly.insuranceFeesOption1.doSoHere') }}</span>
              <br />
              <b-image v-if="collapse.displayImage" :src="require(`../assets/security.webp`)"></b-image>
            </div>
          </div>
        </b-collapse>
      </div>
    </div>
  </div>
</template>

<script>
import { StripeElementPayment } from "@vue-stripe/vue-stripe";
import PaymentRequestService from "@/services";
import LanguageSelector from "./atomic/LanguageSelector.vue";
export default {
  name: "AdditionalSales",
  components: {
    StripeElementPayment,
    LanguageSelector,
  },
  props: {
    paymentId: String,
  },
  data() {
    return {
      totalAmount: 0,
      depositWithoutFees: false,
      identiyVerified: null,
      verifyIdentityChecked: true,
      stripeCustomerId: null,
      stripePaymentIntentId: null,
      flatId: null,
      isPermalink: null,
      startDate: null,
      endDate: null,
      pi: null,
      booking: null,
      deposit: null,
      depositFees: null,
      serviceFees: null,
      applicantName: null,
      acceptedTermsOfService: false,
      firstName: null,
      lastName: null,
      birthDate: null,
      address: null,
      phoneNumber: null,
      email: null,
      loading: false,
      stripeElementComplete: false,
      payment: null,
      pk: process.env.VUE_APP_STRIPE_PUBLIC_KEY,
      elementsOptions: {
        appearance: {}, // appearance options
      },
      confirmParams: {
        return_url: null, // success url
      },
      isOpen: 0,
      collapses: [
        {
          securityFees: false,
          commitment: true,
          bankSecurity: false,
          title: this.$t("helloPage.onlineCheckinPage2.depositOnly.insuranceFeesOption1.commitmentTitle"),
          text: this.$t("helloPage.onlineCheckinPage2.depositOnly.insuranceFeesOption1.commitmentText"),
          displayImage: false,
        },
        {
          securityFees: false,
          commitment: false,
          bankSecurity: true,
          title: this.$t("helloPage.onlineCheckinPage2.depositOnly.insuranceFeesOption1.securityTitle"),
          text: this.$t("helloPage.onlineCheckinPage2.depositOnly.insuranceFeesOption1.securityText"),
          displayImage: true,
        },
      ],
    };
  },
  watch: {
    address(old, newV) {
      console.log(newV);
    },
  },
  computed: {
    isButtonDisabled() {
      return !this.firstName ||
        !this.lastName ||
        !this.email ||
        !this.phoneNumber ||
        !this.startDate ||
        !this.endDate
        ? true
        : false;
    },
  },
  created() {
    PaymentRequestService.getPayment(this.paymentId)
      .then((response) => {
        this.payment = response.data;
        if (this.payment.additionalSalesPaymentStatus == "SUCCEEDED") {
          window.location.href = "/error";
        }
        this.firstName = this.payment.firstName;
        this.lastName = this.payment.lastName;
        this.email = this.payment.email;
        this.phoneNumber = this.payment.phoneNumber;
        this.totalAmount = this.payment.additionalSalesTotalAmount * 100;
        console.log(this.totalAmount);
        PaymentRequestService.createPaymentIntent(
          this.firstName,
          this.lastName,
          this.email,
          this.phoneNumber,
          this.payment.paymentRequest.id,
          true,
          this.payment.additionalSalesTotalAmount,
          this.payment.stripeCustomerId
        )
          .then(async (response) => {
            this.pi = undefined;
            await this.$nextTick();
            this.elementsOptions.clientSecret = response.data.pi;
            this.stripeCustomerId = response.data.stripeCustomerId;
            this.stripePaymentIntentId = response.data.stripePaymentIntentId;
            console.log(
              "Payment Intent Asked",
              this.elementsOptions.clientSecret
            );
            this.pi = response.data.pi;
            this.confirmParams.return_url = encodeURI(
              process.env.VUE_APP_URL + "/additional-sales-success/" +
              this.payment.id +
              "?stripePaymentIntentId=" +
              this.stripePaymentIntentId
            );
            console.log(this.confirmParams.return_url);
            this.$el.getElementsByClassName("stripe-div").value = false;
          })
          .catch((error) => console.error(error));
        // If not permalink and already payed. Then directly to success page
        /*if (
            this.paymentRequest.payments.length != 0 &&
            !this.paymentRequest.isPermalink
          ) {
            this.$router.push({
              name: "success",
              query: {
                firstName: this.paymentRequest.payments[0].firstName,
                lastName: this.paymentRequest.payments[0].lastName,
                email: this.paymentRequest.payments[0].email,
                phoneNumber: this.paymentRequest.payments[0].phoneNumber,
                applicantName: this.paymentRequest.flatId,
                reservationId: this.paymentRequest.reservationId,
                startDate: this.paymentRequest.startDate,
                endDate: this.paymentRequest.endDate,
              },
            });
          }*/
        this.applicantName =
          this.payment["paymentRequest"]["owner"]["commercialName"];
      })
      .catch((error) => {
        window.location.href = "/error";
        console.error(error);
      });
  },
  methods: {
    onStripeError(error) {
      console.log(error.message);
      this.$buefy.notification.open({
        message: error.message,
        position: "is-bottom-right",
        type: "is-danger",
        hasIcon: true,
      });
    },
    onStripeElementChange(change) {
      this.stripeElementComplete = change.complete;
    },
    reset() {
      this.$router.push({
        name: "home",
        params: { paymentRequestId: this.paymentRequest.shortId },
      });
    },
    pay() {
      this.$refs.paymentRef.submit();
    },
  },
};
</script>
<style scoped>
/* Tally-inspired styling for payment form */
.payment-container {
  max-width: 600px;
  background-color: var(--tally-white);
  border: 1px solid var(--tally-border);
  border-radius: var(--tally-radius-lg);
  padding: var(--tally-space-6);
  box-shadow: var(--tally-shadow-card);
  margin: 0 auto;
}

@media (max-width: 768px) {
  .payment-container {
    border: none;
    box-shadow: none;
  }
}

.header {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  gap: var(--tally-space-4);
  margin-bottom: var(--tally-space-6);
}

.header h4 {
  font-size: var(--tally-text-2xl);
  font-weight: var(--tally-font-semibold);
  color: var(--tally-text-primary);
  margin: 0;
  line-height: 1;
}

.header >>> .lang-selector {
  display: flex;
  align-items: center;
}

.stripe-div {
  display: flex;
  flex-direction: column;
  gap: var(--tally-space-4);
}

/* Force all children to respect the gap and remove any default margins */
.stripe-div > * {
  margin-top: 0 !important;
  margin-bottom: 0 !important;
}

.collapses {
  margin-top: 0 !important;
  display: flex;
  flex-direction: column;
  gap: var(--tally-space-3);
}

.card {
  background-color: var(--tally-white);
  border: 1px solid var(--tally-border);
  border-radius: var(--tally-radius-md);
  overflow: hidden;
  transition: border-color var(--tally-transition-fast);
}

.card:hover {
  border-color: var(--tally-text-muted);
}

.card-header {
  display: flex;
  align-items: center;
  padding: var(--tally-space-3) var(--tally-space-4);
  background-color: var(--tally-white);
  cursor: pointer;
  user-select: none;
}

.card-header-title {
  flex: 1;
  font-size: var(--tally-text-sm);
  font-weight: var(--tally-font-medium);
  color: var(--tally-text-primary);
  margin: 0;
  padding: 0;
}

.card-header-icon {
  display: flex;
  align-items: center;
  margin-right: var(--tally-space-2);
  color: var(--tally-text-muted);
}

.card-content {
  padding: 0 var(--tally-space-4) var(--tally-space-4) var(--tally-space-4);
}

.content {
  font-size: var(--tally-text-sm);
  color: var(--tally-text-secondary);
  line-height: var(--tally-leading-relaxed);
}

.pointer {
  cursor: pointer;
  color: var(--tally-primary);
}

.pointer:hover {
  text-decoration: underline;
}

/* Button styling */
button {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  padding: 12px 24px;
  font-family: var(--tally-font-family);
  font-size: var(--tally-text-sm);
  font-weight: var(--tally-font-medium);
  color: var(--tally-white);
  background-color: var(--tally-primary);
  border: none;
  border-radius: var(--tally-radius-md);
  cursor: pointer;
  transition: background-color var(--tally-transition-normal);
  margin-top: 0;
}

button:focus {
  box-shadow: none !important;
  border-color: transparent !important;
}

button:hover:not(:disabled) {
  background-color: var(--tally-primary-hover);
}

button:disabled {
  background-color: var(--tally-primary);
  color: rgba(255, 255, 255, 0.5) !important;
  opacity: 1;
  cursor: not-allowed;
}

button.is-loading {
  position: relative;
  color: transparent;
}
</style>
